import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { lastValueFrom } from '@services';
import { RmsModule } from '@rms';
import { OutboundDataService } from '../../../../../services/outbound-data.service';
import { RmsPulldownRef } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { ReportService } from '../../../../../services/report.service';

@Component({
  selector: 'app-outbound-reconciliation',
  imports: [RmsModule],
  templateUrl: './outbound-reconciliation.component.html',
  styleUrl: './outbound-reconciliation.component.scss'
})
export class OutboundReconciliationComponent implements OnInit {
  Rows: any[] = [];
  Loading = true;
  FilterDate: string | null = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  MissingOnly = false;
  Search = '';
  Page = 0;
  readonly PageSize = 50;
  get pageRows(): any[] { return this.visibleRows.slice(this.Page * this.PageSize, (this.Page + 1) * this.PageSize); }
  get pageStart(): number { return this.visibleRows.length ? this.Page * this.PageSize + 1 : 0; }
  get pageEnd(): number { return Math.min((this.Page + 1) * this.PageSize, this.visibleRows.length); }
  get visibleRows(): any[] {
    const search = this.Search.trim().toLowerCase();
    return this.Rows.filter(r => (!this.MissingOnly || !r.FullyTransmitted) &&
      (!search || `${r.OrderID} ${r.Customer ?? ''} ${r.Warehouse ?? ''}`.toLowerCase().includes(search)));
  }
  LoadError = '';
  SendingOrderID: number | null = null;
  SendResult = '';
  SendError = '';

  async sendDocuments(row: any, resend = false) {
    if (this.SendingOrderID !== null) return;
    const types = [
      { type: 'Delivery Order', sent: !!row.DOFlag },
      { type: 'Bill of Lading', sent: !!row.BOLFlag }
    ].filter(d => resend ? d.sent : !d.sent);
    if (!types.length) return;
    this.SendingOrderID = row.OrderID;
    this.SendError = ''; this.SendResult = '';
    const accepted: string[] = [];
    try {
      for (const document of types) {
        const pdf = await this.reports.generatePDF(document.type === 'Delivery Order' ? 'DeliveryOrder' : 'BillOfLading', { OrderID: row.OrderID });
        const response = await lastValueFrom(this.outboundData.sendDocument(row.OrderID, document.type, [], pdf.split(',')[1]));
        if (!response?.testMode) throw new Error('Unexpected email response. Check your inbox before retrying.');
        accepted.push(document.type);
        this.SendResult = `Order #${row.OrderID}: ${accepted.join(' and ')} accepted by Microsoft for m.bray@royalny.com only. Warehouse delivery status is unchanged.`;
      }
    } catch (error: any) {
      this.SendError = error?.error?.error || error?.message || 'Could not confirm the test email. Check your inbox before retrying.';
    } finally { this.SendingOrderID = null; this.cdr.markForCheck(); }
  }
  private loadRequest = 0;

  constructor(
    private outboundData: OutboundDataService,
    private pulldownRef: RmsPulldownRef,
    private cdr: ChangeDetectorRef,
    private reports: ReportService
  ) { }

  async ngOnInit() {
    await this.load();
  }

  async load() {
    const request = ++this.loadRequest;
    this.Loading = true;
    this.LoadError = '';
    this.Rows = [];
    this.Page = 0;
    try {
      const rows = await lastValueFrom(this.outboundData.getReconciliation(this.FilterDate ?? undefined));
      if (request === this.loadRequest) {
        if (rows?.some((row: any) => !Object.prototype.hasOwnProperty.call(row, 'DOSentDate'))) {
          this.LoadError = 'Transmission reconciliation requires the updated API. Restart the Node API, then retry.';
        } else { this.Rows = rows ?? []; }
      }
    } catch {
      if (request === this.loadRequest) this.LoadError = 'Could not load reconciliation. Please retry.';
    } finally {
      if (request === this.loadRequest) { this.Loading = false; this.cdr.markForCheck(); }
    }
  }

  onFilterDateChange(date: string | null) {
    this.FilterDate = date;
    this.load();
  }

  get missingCount(): number {
    return this.Rows.filter(r => !r.FullyTransmitted).length;
  }

  returnToList() {
    this.pulldownRef.close();
  }
}
